/**
 * Blog Pagination - AJAX Handler
 */

export function initBlogPagination() {
  const blogSection = document.querySelector("#blog-posts");
  const postsGrid = blogSection?.querySelector(".grid");
  const paginationContainer =
    blogSection?.querySelector(".blog-pagination")?.parentElement;

  if (!blogSection || !postsGrid || !paginationContainer) {
    return;
  }

  // Cria loading overlay
  const loadingOverlay = document.createElement("div");
  loadingOverlay.className =
    "absolute inset-0 bg-white/80 flex items-center justify-center z-10 hidden";
  loadingOverlay.innerHTML = `
    <div class="flex flex-col items-center gap-3">
      <div class="w-12 h-12 border-4 border-orange-500 border-t-transparent rounded-full animate-spin"></div>
      <span class="text-gray-600 font-medium">Carregando...</span>
    </div>
  `;

  // Adiciona posição relativa ao container dos posts
  const postsContainer = postsGrid.parentElement;
  postsContainer.style.position = "relative";
  postsContainer.appendChild(loadingOverlay);

  // Event delegation para links de paginação
  paginationContainer.addEventListener("click", async (e) => {
    const link = e.target.closest("a.page-numbers");

    if (!link) return;

    e.preventDefault();

    // Extrai o número da página da URL
    const url = new URL(link.href);
    const paged =
      url.searchParams.get("paged") ||
      url.pathname.match(/\/page\/(\d+)/)?.[1] ||
      (link.classList.contains("prev") ? getPreviousPage() : null) ||
      (link.classList.contains("next") ? getNextPage() : null) ||
      1;

    // Mostra loading
    loadingOverlay.classList.remove("hidden");

    // Scroll suave para o topo da seção
    blogSection.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });

    try {
      const response = await fetch(blogPagination.ajaxurl, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          action: "blog_pagination",
          nonce: blogPagination.nonce,
          paged: paged,
          category_id:
            typeof window.getActiveCategory === "function"
              ? window.getActiveCategory() || ""
              : "",
        }),
      });

      const data = await response.json();

      if (data.success) {
        // Atualiza os posts
        postsGrid.innerHTML = data.posts_html;

        // Atualiza a paginação
        if (data.pagination_html) {
          paginationContainer.querySelector(".blog-pagination").innerHTML =
            data.pagination_html;
        } else {
          paginationContainer.innerHTML = "";
        }

        // Atualiza a URL sem recarregar a página
        const newUrl = paged > 1 ? `?paged=${paged}` : window.location.pathname;
        window.history.pushState({ paged }, "", newUrl);
      }
    } catch (error) {
      console.error("Erro ao carregar posts:", error);
    } finally {
      loadingOverlay.classList.add("hidden");
    }
  });

  // Funções auxiliares para prev/next
  function getCurrentPage() {
    const current = paginationContainer.querySelector(".page-numbers.current");
    return current ? parseInt(current.textContent) : 1;
  }

  function getPreviousPage() {
    return Math.max(1, getCurrentPage() - 1);
  }

  function getNextPage() {
    return getCurrentPage() + 1;
  }

  // Suporte ao botão voltar do navegador
  window.addEventListener("popstate", (e) => {
    if (e.state && e.state.paged) {
      location.reload();
    }
  });
}
